import styles from "./Footer.module.css";

import Links from "../../services/constants/Links";

import facebookLogo from "../../assets/icons/socialMedia/facebook.svg";
import instagramLogo from "../../assets/icons/socialMedia/instagram.svg";
import linkedinLogo from "../../assets/icons/socialMedia/linkedin.svg";
import twitterLogo from "../../assets/icons/socialMedia/twitter.svg";
import youtubeLogo from "../../assets/icons/socialMedia/youtube.svg";

const Footer = () => {
    const socialData = [
        {
            id: 1,
            alt: "facebook",
            url: Links.SOCIAL_FACEBOOK,
            icon: facebookLogo,
            color: "#4267B2",
        },
        {
            id: 2,
            alt: "x",
            url: Links.SOCIAL_X,
            icon: twitterLogo,
            color: "#000",
        },
        {
            id: 3,
            alt: "youtube",
            url: Links.SOCIAL_YOUTUBE,
            icon: youtubeLogo,
            color: "#FF0000",
        },
        {
            id: 4,
            alt: "linkedin",
            url: Links.SOCIAL_LINKEDIN,
            icon: linkedinLogo,
            color: "#0077B5",
        },
        {
            id: 5,
            alt: "instagram",
            url: Links.SOCIAL_INSTAGRAM,
            icon: instagramLogo,
            color: "#405DE6",
        },
    ];

    const linksData = [
        {
            id: 1,
            text: `© Riksbyggen ${new Date().getFullYear()}`,
            url: Links.RB_RIKSBYGGEN,
        },
        {
            id: 2,
            text: "Cookies",
            url: Links.RB_COOKIES
        },
        {
            id: 3,
            text: "Integritet",
            url: Links.RB_INTEGRITY_POLICY
        },
        {
            id: 4,
            text: "Villkor",
            url: Links.RB_USE_TERMS,
        },
        {
            id: 5,
            text: "Om webbplatsen",
            url: Links.DUP_READ_MORE
        },
    ];

    return (
        <footer className={styles.footer}>
            <div className={styles.footer_inner}>
                <p className={styles.footer_label}>Besök oss i våra andra kanaler</p>
                <div className={styles.footer_socials}>
                    {socialData.map((social) => (
                        <a
                            key={social.id}
                            className={`${styles.footer_img_link} ${social.alt}`}
                            href={social.url}
                            target="_blank">
                            {social.alt}
                        </a>
                    ))}
                </div>
                <div className={styles.footer_socials}>
                    {linksData.map((link) => (
                        <a
                            key={link.id}
                            className={styles.footer_link}
                            href={link.url}
                            target="_blank">
                            {link.text}
                        </a>
                    ))}
                </div>
            </div>
        </footer>
    );
};

export default Footer;
